import api from '../api';
import type { ICourse } from '../../types/course';
import type { IBatch } from '../../types/batch'; // ✅ FIX: Import the IBatch type


// ✅ FIX: Removed 'export' from each function. They will be exported together below.
const getAllPublishedCourses = async (): Promise<ICourse[]> => {
  try {
    const response = await api.get<ICourse[]>('/courses');
    return response.data;
  } catch (error: any) {
    throw new Error('Failed to fetch courses.');
  }
};

const getAllCoursesForAdmin = async (): Promise<ICourse[]> => {
  try {
    const response = await api.get<ICourse[]>('/courses/all');
    return response.data;
  } catch (error: any) {
    throw new Error('Failed to fetch courses for admin.');
  }
};

const getCourseBySlug = async (slug: string): Promise<ICourse> => {
  try {
    const response = await api.get<ICourse>(`/courses/slug/${slug}`);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to fetch course.');
  }
};

const getCourseForEdit = async (id: string): Promise<ICourse> => {
    try {
      const response = await api.get<ICourse>(`/courses/${id}/full`);
      return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
      throw new Error('Failed to fetch full course details for editing.');
    }
  };

const createCourse = async (payload: Partial<ICourse>): Promise<{ message: string; course: ICourse }> => {
  try {
    const response = await api.post<{ message: string; course: ICourse }>('/courses', payload);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to create course.');
  }
};

const updateCourse = async (id: string, payload: Partial<ICourse>): Promise<{ message: string; course: ICourse }> => {
  try {
    const response = await api.put<{ message: string; course: ICourse }>(`/courses/${id}`, payload);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to update course.');
  }
};

const deleteCourse = async (id: string): Promise<string> => {
  try {
    const response = await api.delete<{ message: string }>(`/courses/${id}`);
    return response.data.message;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to delete course.');
  }
};

const toggleCoursePublication = async (id: string): Promise<{ message: string; course: ICourse }> => {
    try {
      const response = await api.patch<{ message: string; course: ICourse }>(`/courses/${id}/publish`);
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update course publication status.');
    }
  };


  // ✨ NEW: Add this function to your service file
export const getCourseDetailsForMentor = async (courseId: string): Promise<{ course: ICourse; batches: IBatch[] }> => {
  try {
    const response = await api.get(`/courses/${courseId}/details`);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to fetch course details.');
  }
};

// ✅ FIX: Group all functions into a single object for export.
const courseService = {
    getAllPublishedCourses,
    getAllCoursesForAdmin,
    getCourseBySlug,
    getCourseForEdit,
    createCourse,
    updateCourse,
    deleteCourse,
    toggleCoursePublication, 
    getCourseDetailsForMentor
};

export default courseService;